import React from 'react'
import { Outlet } from 'react-router-dom'

const PfToolsRouter = () => {
  return (
    <Outlet/>    
  )
}

export default PfToolsRouter